import Vue from 'vue';
import Router from 'vue-router';
import config from '@/../vue.config';
import Search from '@/components/search/Search';
import Viewer from '@/components/viewer/Viewer';

Vue.use(Router);

export default new Router({
  base: config.publicPath,
  mode: 'hash',
  routes: [
    {
      path: '/:lang/embed/viewer/:documentId/:pageNum',
      name: 'ViewerEmbed',
      component: Viewer,
      props: { embed: true },
      meta: {
        layout: 'minimal',
      },
    },
    {
      path: '/:lang/embed/search/:collectionIds',
      name: 'SearchEmbed',
      component: Search,
      props: (route) => ({
        embed: true,
        collectionIds: route.params.collectionIds.split(',').map((id) => parseInt(id, 10)),
      }),
      meta: {
        layout: 'minimal',
      },
    },
  ],
});
